import { Input } from 'components/atoms';
import { useFormikField } from 'hooks/useFormikField';
import { IInputProps } from 'types/components/inputs/input.interface';

const CheckboxInputForm = ({ name, isError = true, ...props }: IInputProps) => {
  const [field, { error, status }, { setValue }] = useFormikField<any>(name);

  return (
    <Input.Checkbox
      displayMode={status?.displayMode}
      isLoading={status?.isLoading}
      {...props}
      {...field}
      onChange={e => {
        field.onChange(e);
        props.onChange && props.onChange(e);
      }}
      // value={field.value}
      checked={field.value}
      error={error}
    />
  );
};

export default CheckboxInputForm;
